import React, { useEffect, useState } from 'react';
import GridInputs from '../../components/common/inputs/GridInputs';
import axios from 'axios';
import { SubmitButton } from '../../components/common/button/CustomButtons';
import useConfirm from '../../components/common/useConfirm';
import { Grid, SelectChangeEvent, Stack, Typography } from '@mui/material';
import CustomUploadButton from '../../components/common/button/CustomUploadButton';
import { Loader } from '../../components/common/Loader';
import moment from 'moment';
import { StyledNotesField } from '../../components/common/FormControlMui';
import DescriptionTextfield from '../../components/common/DescriptionNotes';
import ModalCustom from '../../components/common/Modal';
import PartTable from './components/PartTable';
import { DivStyled } from '../../assets/styles/components/DivStyledLableInputs';
import {
  AddIconButton,
  RemoveIconButton,
} from '../../components/common/button/CustomIconButton';
import DateGridMui from '../../components/common/dateCustom/DateGridMui';
import TableForm from './components/TableForm';
const Create = ({
  id,
  setIsModal,
}: {
  id?: string | null;
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const [data, setData] = useState<any>({});
  const [render, setRender] = useState(false);
  const [files, setFiles] = useState(null);
  const [otherFiles, setOtherFiles] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isPartModal, setIsPartModal] = useState(false);
  const [DialogSubmit, confirmSubmit] = useConfirm(
    `${id ? 'Update ' : 'Create '}`,
    `Are you sure you want to ${id ? 'update' : 'save'} this?`,
  );

  useEffect(() => {
    if (id) {
      axios
        .get(`/api/qualityAlertRoute/${id}`)
        .then((res) => {
          setData(res.data);
        })
        .catch((err) => console.log(err));
    }
  }, [id]);

  function handleModuleData(
    e: React.ChangeEvent<HTMLInputElement> | SelectChangeEvent<unknown>,
  ) {
    setData((prev: any) => ({ ...prev, [e.target.name]: e.target.value }));
  }

  const handleSumbit = async () => {
    const ans = await confirmSubmit();
    if (!ans) return;
    setIsLoading(true);
    const formData = new FormData();
    if (typeof data.part_id === 'object') {
      data.part_id = data.part_id._id;
    }
    for (const key in data) {
      if (data[key]) {
        if (key !== 'files' && key !== 'otherFiles')
          formData.append(key, data[key]);
      }
    }
    if (files) {
      for (const key of Object.keys(files)) {
        formData.append('files', files[key]);
      }
    }
    if (otherFiles) {
      for (const key of Object.keys(otherFiles)) {
        formData.append('otherFiles', otherFiles[key]);
      }
    }
    if (id) {
      await axios
        .put(`/api/qualityAlertRoute/${id}`, formData)
        .then((res) => {
          setIsLoading(false);
          setIsModal(false);
        })
        .catch((err) => console.log(err));
    } else {
      await axios
        .post('/api/qualityAlertRoute', formData)
        .then((res) => {
          setIsLoading(false);
          setIsModal(false);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log(err);
        });
    }
  };

  return (
    <>
      <Loader loader={isLoading} />
      <DivStyled style={{ alignItems: 'center' }}>
        <label>{'Part Number'}</label>
        <div
          style={{
            borderLeft: '2px solid #ced4da',
            paddingLeft: '1rem',
            width: '100%',
          }}
        >
          <Grid container xs={12} direction="row" alignItems={'center'}>
            <Grid item xs={10}>
              <p
                style={{
                  fontSize: '1.6rem',
                }}
              >
                {typeof data?.part_id === 'object' && data?.part_id !== null
                  ? data?.part_id?.part_number
                  : data?.partNumber || ''}
              </p>
            </Grid>

            {data.part_id ? (
              <Grid item xs={2}>
                <RemoveIconButton
                  tooltipTitle="remove part"
                  onClick={() => {
                    data.part_id = null;
                    data.partNumber = null;
                    data.customerName = null;

                    setRender((prev) => !prev);
                  }}
                />
              </Grid>
            ) : (
              <Grid item xs={2}>
                <AddIconButton
                  tooltipTitle="add part"
                  onClick={() => {
                    setIsPartModal(true);
                  }}
                />
              </Grid>
            )}
          </Grid>
        </div>
      </DivStyled>
      <DivStyled style={{ alignItems: 'center' }}>
        <label>{'Part Name / पाट का नाम'}</label>
        <div
          style={{
            borderLeft: '2px solid #ced4da',
            paddingLeft: '1rem',
            width: '100%',
          }}
        >
          {data?.part_id?.part_name || data?.partName}
        </div>
      </DivStyled>
      <DivStyled style={{ alignItems: 'center' }}>
        <label>{'Customer / करटमर का नाम'}</label>
        <div
          style={{
            borderLeft: '2px solid #ced4da',
            paddingLeft: '1rem',
            width: '100%',
          }}
        >
          {data?.part_id?.customer_id?.customer_name || data?.customerName}
        </div>
      </DivStyled>
      <DateGridMui
        lable="Date"
        onChange={(date: any) => {
          data.moduleData = date;
          setRender((prev) => !prev);
        }}
        value={moment(data.moduleDate) || null}
      />
      <GridInputs
        id={'qty'}
        name={'qty'}
        html_for={'qty'}
        label_name={'Qty'}
        input_type={'text'}
        focusType={'onblur'}
        value={data?.qty}
        onChange={handleModuleData}
      />
      <StyledNotesField>
        <DescriptionTextfield
          name="problem_desc"
          onChange={handleModuleData}
          value={data.problem_desc || ''}
          label="Problem Description /समरया का कारण"
        />
      </StyledNotesField>
      <Typography
        sx={{
          width: '60vw',
          maxWidth: '800px',
          border: '1px solid black',
          marginTop: '5px',
        }}
      >
        हम सभी लोग ऊपर दी हुई कमपलेट से सहमत है । और हम सबको इसके लिए खेद है ।
        और ये कमपलेट दोबारा न आए इसके लिए हम उचित कौरेकटिव एकसन और पृभेनटिभ एकसन
        लेगें। <br />
        We below signed accept our sincere apologies for the inconvenience at
        customer end in respect to the above issue. We are committed to take
        adequate action as corrective and Preventive for the same.
      </Typography>
      <TableForm moduleData={data} />
      <Stack direction="row" flex="1" gap={9}>
        <Grid item xs={3}>
          <CustomUploadButton
            lable={'Not  Ok Snap'}
            id="not_ok_snap"
            multiple
            accept="image/png,image/jpeg,image/jpg,application/pdf"
            onChange={(e) => {
              setFiles(e.target.files);
            }}
          />
        </Grid>
        <Grid item xs={3}>
          <CustomUploadButton
            lable={'Ok Snap'}
            id="ok_snap"
            multiple
            accept="image/png,image/jpeg,image/jpg,application/pdf"
            onChange={(e) => {
              setOtherFiles(e.target.files);
            }}
          />
        </Grid>
      </Stack>
      <div
        className="btn_save"
        style={{
          position: 'absolute',
          right: '140px',
          top: '-0.6px',
        }}
      >
        <SubmitButton
          label={`${id ? 'update' : 'submit'}`}
          type="button"
          onClick={handleSumbit}
        />
      </div>
      <DialogSubmit />
      <ModalCustom
        openModal={isPartModal}
        closeModal={() => {
          setIsPartModal(false);
        }}
        title="PART"
      >
        <PartTable moduleData={data} />
      </ModalCustom>
    </>
  );
};

export default Create;
